import axios, { CreateAxiosDefaults } from 'axios';
import { useMemo } from 'react';
import { useConfigApiContext } from '../context/ConfigApiContext';

export default function useAxiosInstance() {
  const { apiBaseUrl, apiPath, headers } = useConfigApiContext();
  const source = axios.CancelToken.source();

  const config: CreateAxiosDefaults = useMemo(
    () => ({
      baseURL: `${apiBaseUrl}${
        apiBaseUrl?.endsWith('/') || apiPath.startsWith('/') ? '' : '/'
      }${apiPath}`,
      headers: {},
      cancelToken: source.token,
    }),
    [apiBaseUrl, apiPath, source.token]
  );

  headers.forEach((header) => {
    if (config.headers) {
      config.headers[header.key] = header.value;
    }
  });

  const axiosInstance = useMemo(() => axios.create(config), [config]);

  return { axios: axiosInstance, cancel: source.cancel };
}
